export interface StoredAuthData {
  token: string | null;
  user: {
    userId: number;
    username: string;
  } | null;
}

const TOKEN_STORAGE_KEY = 'taskcenter_token';
const USER_STORAGE_KEY = 'taskcenter_user';
const LOGOUT_EVENT = 'taskcenter:auth-logout';

export const getStoredAuth = (): StoredAuthData => {
  if (typeof window === 'undefined') {
    return { token: null, user: null };
  }

  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  const rawUser = localStorage.getItem(USER_STORAGE_KEY);
  let user: StoredAuthData['user'] = null;

  if (rawUser) {
    try {
      user = JSON.parse(rawUser);
    } catch (error) {
      console.warn('Failed to parse stored user info', error);
      localStorage.removeItem(USER_STORAGE_KEY);
    }
  }

  if (!token && rawUser) {
    localStorage.removeItem(USER_STORAGE_KEY);
  }

  return { token, user };
};

export const setStoredAuth = (token: string, user: StoredAuthData['user']) => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(TOKEN_STORAGE_KEY, token);
  if (user) {
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
  }
};

export const clearStoredAuth = (options?: { emitEvent?: boolean }) => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(USER_STORAGE_KEY);

  if (options?.emitEvent !== false) {
    window.dispatchEvent(new Event(LOGOUT_EVENT));
  }
};

export const getStoredToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(TOKEN_STORAGE_KEY);
};

export const onAuthLogout = (handler: () => void) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }
  const listener = () => handler();
  window.addEventListener(LOGOUT_EVENT, listener);
  return () => window.removeEventListener(LOGOUT_EVENT, listener);
};
